import { useState } from "react";
import { FolderOpen, HelpCircle, Loader2, Trash2 } from "lucide-react";
import { ClientPicker } from "../loans/ClientPicker";
import { DOC_TYPE_OPTIONS } from "./docTypes";
import { PendingFileRow } from "./PendingFileRow";

const NearMatch = ({ group, gi, onAssignFolder, busy }) => (
  <div className="flex flex-col gap-2 rounded-[12px] border border-[#cfe0ff] bg-[#eef4ff] px-3.5 py-3 sm:flex-row sm:items-center sm:justify-between" data-testid={`bandeja-near-${gi}`}>
    <span className="flex items-center gap-2 text-sm font-bold text-[#0a47be]"><HelpCircle className="h-4 w-4" /> ¿Es {group.near_client_name}?</span>
    <div className="flex flex-wrap gap-2">
      <button type="button" disabled={busy} onClick={() => onAssignFolder(group, group.near_borrower_id)} className="tr-btn-primary px-3 py-2 text-xs" data-testid={`bandeja-near-yes-${gi}`}>Sí, es este cliente</button>
    </div>
  </div>
);

export const PendingGroup = ({ group, gi, onAssignFolder, onAssignTypeGroup, onDiscardGroup, fileHandlers }) => {
  const first = group.files.find((f) => f.suggested_borrower_id);
  const [client, setClient] = useState(first ? { borrower_id: first.suggested_borrower_id, name: first.suggested_client_name, persona: first.suggested_client_persona,
    persona_label: first.suggested_client_persona === "PM" ? "Persona moral" : "Persona física" } : null);
  const [docType, setDocType] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (fn, ...args) => {
    setBusy(true);
    try { await fn(...args); } finally { setBusy(false); }
  };
  const options = DOC_TYPE_OPTIONS.filter(([k]) => client?.persona === "PM" || k !== "pm_acta");
  return (
    <section className="tr-card space-y-4 p-4 sm:p-5" data-testid={`bandeja-group-${gi}`}>
      <div className="flex flex-wrap items-start justify-between gap-2.5">
        <div className="flex min-w-0 items-start gap-2.5">
          <FolderOpen className="mt-0.5 h-5 w-5 shrink-0 text-[#0f5ef7]" />
          <div className="min-w-0">
            <h2 className="break-words text-base font-bold text-[#182235]" data-testid={`bandeja-group-folder-${gi}`}>{group.folder}</h2>
            <p className="break-all font-mono text-[11px] text-[#5b667a]">{group.group_path || "(raíz del ZIP)"} · {group.files.length} {group.files.length === 1 ? "archivo" : "archivos"}</p>
          </div>
        </div>
        <button type="button" disabled={busy} onClick={() => onDiscardGroup(group)} className="tr-btn-danger px-3 py-1.5 text-xs" data-testid={`bandeja-discard-group-${gi}`}>
          <Trash2 className="h-3.5 w-3.5" /> Descartar grupo
        </button>
      </div>
      {group.near_borrower_id && <NearMatch group={group} gi={gi} busy={busy} onAssignFolder={(g, b) => run(onAssignFolder, g, b)} />}
      <div className="grid grid-cols-1 gap-2 lg:grid-cols-[1fr_auto]">
        <ClientPicker value={client} onChange={setClient} testPrefix={`bandeja-folder-client-${gi}`} />
        <button type="button" disabled={!client || busy} onClick={() => run(onAssignFolder, group, client.borrower_id)} className="tr-btn-primary h-11 px-4 text-sm" data-testid={`bandeja-assign-folder-${gi}`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Asignar carpeta a este cliente"}
        </button>
        <select value={docType} onChange={(e) => setDocType(e.target.value)} className="tr-input" data-testid={`bandeja-group-type-${gi}`} aria-label="Tipo para todo el grupo">
          <option value="">Tipo de documento para todo el grupo…</option>
          {options.map(([k, label]) => <option key={k} value={k}>{label}</option>)}
        </select>
        <button type="button" disabled={!client || !docType || busy} onClick={() => run(onAssignTypeGroup, group, client, docType)} className="tr-btn-light h-11 px-4 text-sm" data-testid={`bandeja-assign-type-group-${gi}`}>
          Asignar tipo a todos los archivos del grupo
        </button>
      </div>
      <ul className="space-y-2.5">
        {group.files.map((f) => <PendingFileRow key={f.id} f={f} {...fileHandlers} />)}
      </ul>
    </section>
  );
};
